import { TypingAnimation } from '@shared/ui';
import { Hourglass } from 'lucide-react';

export const LoadingPage = () => {
  return (
    <div className="flex h-screen w-full">
      <div className="justify-content m-auto flex flex-col items-center">
        <TypingAnimation
          text={'Loading... '}
          duration={200}
          className="mb-0 pb-0"
        />
        <Hourglass height={50} width={30} className="animate-rotate-180" />
      </div>
    </div>
  );
};
